import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('template', ['credentials']),
    ...mapState('organization', ['companySize']),
    ...mapState('layouts', ['appConfig']),
    ...mapState('preferences', ['billing_info']),
    organization() {
      if (this.credentials.length)
        return {
          id: this.credentials[0].company_id ?? '000000',
          name: this.credentials[0].name ?? 'No company name provided',
        }
      else
        return {
          id: 'No company provided',
          name: 'No company name provided',
        }
    },
  },
  methods: {
    storeJimoMetric(name, additionalData, product) {
      const prefix = `[${product.toUpperCase()}]`

      try {
        if (typeof window !== 'undefined') {
          const win = window

          const eligibleUserPackages = [
            'MIGR-QService - Business Operational',
            'MIGR-QService - Customer Interaction',
            'MIGR-QSales - Business Operational',
            'MIGR-QSales - Customer Interaction',
            'MIGR-Q360 - Business Operational',
            'MIGR-Q360 - Customer Interaction',
            'Qontak 360 - Business Operational',
            'Qontak 360 - Customer Interaction',
            'Qontak Broadcast',
            'Sales Suite Plus - Business Operational',
            'Sales Suite Plus - Customer Interaction',
            'Sales Suite Ultimate - Business Operational',
            'Sales Suite Ultimate - Customer Interaction',
            'Service Suite Plus - Business Operational',
            'Service Suite Plus - Customer Interaction',
            'Service Suite Ultimate - Business Operational',
            'Service Suite Ultimate - Customer Interaction',

            // Separator for new updated packages ============================================

            // "-", // Not needed
            'Gigachat',
            // "MIGR-Q360 - Customer Interaction", // Duplicate - already defined above
            // "MIGR-QSales - Customer Interaction", // Duplicate - already defined above
            // "MIGR-QService - Customer Interaction", // Duplicate - already defined above
            'Omnichannel Basic Enterprise Package',
            'Omnichannel Basic Enterprise Package - Unlimited FAQ & MUV',
            'Omnichannel Business Enterprise Package',
            'Omnichannel Business Enterprise Package - Unlimited FAQ & MUV',
            'Omnichannel Business Package',
            'Omnichannel Business Package - Unlimited FAQ & MUV',
            'Omnichannel Pro Enterprise Package',
            'Omnichannel Pro Enterprise Package - Unlimited FAQ & MUV',
            'Omnichannel Pro Package',
            'Omnichannel Pro Package - Unlimited FAQ & MUV',
            'Omnichannel Starter Enterprise Package',
            'Omnichannel Starter Package',
            // "Qontak 360 - Customer Interaction", // Duplicate - already defined above
            // "Qontak Broadcast", // Duplicate - already defined above
            'Qontak Lite',
            'Qontak Service Suites Enterprise',
            'Qontak Service Suites Enterprise - Omnichannel',
            'Qontak Service Suites Enterprise (Trial)',
            'Qontak Service Suites Plus',
            'Qontak Service Suites Plus - Omnichannel',
            'Qontak Service Suites Plus (Trial)',
            'Qontak Service Suites Ultimate',
            'Qontak Service Suites Ultimate - Omnichannel',
            'Qontak Service Suites Ultimate (Trial)',
            // "Sales Suite Plus - Customer Interaction", // Duplicate - already defined above
            // "Sales Suite Ultimate - Customer Interaction", // Duplicate - already defined above
            // "Service Suite Plus - Customer Interaction", // Duplicate - already defined above
            // "Service Suite Ultimate - Customer Interaction", // Duplicate - already defined above
            'Superchat',
            'Whatsapp Direct API',
            'Whatsapp HUB Notification Panel',
            'Qontak 360',
            'Service Suite Ultimate',
            'Service Suite Plus',
            'Sales Suite Ultimate',
            'Sales Suite Plus',
          ]
          const userEligible = eligibleUserPackages.includes(
            this.billing_info?.package_name
          )

          // Track in Jimo if available
          if (win.jimo && userEligible) {
            win.jimo.push([
              'do',
              'mixpanel:track',
              [`${prefix} ${name}`, additionalData],
            ])
          }
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    getOrganizationForMetric() {
      return {
        'Company ID': this.organization.id,
        'Company Name': this.organization.name,
        'Company Size': this.companySize,
      }
    },
  },
}
